import { render } from "./vhpEmpty.vue?vue&type=template&id=288acf68"
import script from "./vhpEmpty.vue?vue&type=script&lang=js"
export * from "./vhpEmpty.vue?vue&type=script&lang=js"

import "./vhpEmpty.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__